module.exports = __webpack_public_path__ + "img/btn_bet_size.0a302b72.png";